import { IdName } from 'api/models';
import { RestaurantDetails } from 'store/restaurantDetailsStore/reducer';

export function getAllPricingLevels(
    restaurant: RestaurantDetails,
    isCatalogDish: boolean
): IdName[] {
    const groupLevels = isCatalogDish ? restaurant.groupPricingLevels ?? [] : [];
    return [...restaurant.pricingLevels, ...groupLevels];
}
